import { useState, useEffect } from 'react';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import { getFormattedDuration } from '@/api/upload';
import { checkImageResourceStatus, ImageResourceStatus } from '../PhotoPreview/util';
import UploadRetryIcon from '../../assets/icon/upload-retry.svg';
import { getOptimizedImageUrl } from '@/utils/image';
import Styles from './mIndex.module.scss';

export interface IVideoPreview {
  className?: string;
  id: string;
  url: string;
  percent?: number;
  duration?: number;
  error?: boolean;
  onRemove: (key: string) => void;
  onRetry?: (key: string) => void;
}

const VideoPreview = ({
  className = '',
  id,
  url,
  percent = url.indexOf("https://") > -1 ? 1 : 0,
  duration,
  error,
  onRemove,
  onRetry = () => {},
}: IVideoPreview) => {
  const [imgLoadStatus, setImgLoadStatus] = useState<ImageResourceStatus>();
  const t = useTranslations();

  useEffect(() => {
    // 本地图片
    if (url && url.startsWith('blob:')) {
      setImgLoadStatus(ImageResourceStatus.local);
      return;
    }

    // 检查图片资源状态
    checkImageResourceStatus(url, (statusCode) => setImgLoadStatus(statusCode));
  }, [url]);

  const handleRemove = () => {
    onRemove(id);
  };

  const handleUploadRetry = () => {
    onRetry(id);
  };

  const showDefaultIcon = !error && (imgLoadStatus === ImageResourceStatus.local || imgLoadStatus == ImageResourceStatus.notFound || imgLoadStatus == ImageResourceStatus.unknown);
  const showAuditIcon =  !error && imgLoadStatus === ImageResourceStatus.audit;

  return (
    <div
      className={cx(Styles.root, className)}
      style={ imgLoadStatus === ImageResourceStatus.success ? { backgroundImage: `url(${getOptimizedImageUrl(url)})` } : {}}
    >
      {
        showDefaultIcon && <div className={Styles.defaultIcon} />
      }
      {
        showAuditIcon && <div className={Styles.auditIcon} />
      }
      {
        !!error && (
          <div className={Styles.errorWrapper}>
            <div className={Styles.errorIcon} onClick={handleUploadRetry}>
              <UploadRetryIcon />
            </div>
            <div className={Styles.errorTips}>{t('tips_thread_upload_retry')}</div>
          </div>
        )
      }
      {
        duration && (
          <div className={Styles.durationWrapper}>
            <div className={Styles.icon} />
            <div className={Styles.duration}>{getFormattedDuration(Number.parseInt(duration.toString()))}</div>
          </div>
        )
      }
      <div className={Styles.remove} onClick={handleRemove} />
      <div className={Styles.tips}>
        {
          percent < 1 ? t('tips_thread_video_percent', { percent: Number.parseInt((percent * 100).toString()) }) : t('tips_thread_video_preview')
        }
      </div>
    </div>
  );
};

export default VideoPreview;
